import { ContentHubType } from 'src/constants';
import { getHubUrl, getUrlPrefix, LEARNING_PATH_URL_PATH } from 'src/utils/getUrl';

export const getLearningPathsHubPart = (pathname?: string): string => {
  const hubUrl = getHubUrl(ContentHubType.LEARNING_PATHS);
  const isAllLearningPathsHubIncluded = pathname?.includes(hubUrl);

  const allLearningPathsHubPart = isAllLearningPathsHubIncluded ? hubUrl : '';

  return allLearningPathsHubPart;
};

export const transformLearningPathUrl = (contentLink: string): string => {
  const hubPath = getHubUrl(ContentHubType.LEARNING_PATHS);

  try {
    const url = new URL(contentLink);
    const learningPrefix = getUrlPrefix();

    if (url.pathname.includes(learningPrefix + `/${LEARNING_PATH_URL_PATH}`)) {
      const [, rest] = url.pathname.split(learningPrefix);

      url.pathname = `${learningPrefix}${hubPath}${rest}`;

      return url.href;
    }
  } catch (error) {
    /* eslint-disable no-console */
    console.error('Invalid URL:', contentLink, error);

    return `${hubPath}/${contentLink}`;
  }

  return contentLink;
};
